import { create } from "zustand";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { Challenge } from "@/models/database/challenges/challenge.model";

interface ChallengeState {
  challenges: Record<
    string,
    { loading: boolean; error: Error | null; slug: string | null }
  >;
  fetchChallenge: (
    client: string,
    state: "ongoing" | "upcoming" | "finished",
    gameType: string
  ) => void;
}

export const useChallengeStore = create<ChallengeState>((set, get) => ({
  challenges: {},
  fetchChallenge: async (client, state, gameType) => {
    const key = `${client}-${state}-${gameType}`;
    const { challenges } = get();
    if (challenges[key]?.slug) {
      return;
    }

    set((state) => ({
      challenges: {
        ...state.challenges,
        [key]: { loading: true, error: null, slug: null },
      },
    }));

    try {
      const docRef = await collectionRef.challenge
        .where("status", "==", state)
        .where("client", "==", client)
        .where("gameType", "==", gameType)
        .where("type", "==", "public")
        .get();

      const challData = docRef?.docs?.[0]?.data() as Challenge;

      if (challData?.slug) {
        set((state) => ({
          challenges: {
            ...state.challenges,
            [key]: { loading: false, error: null, slug: challData.slug },
          },
        }));
      }
    } catch (err) {
      set((state) => ({
        challenges: {
          ...state.challenges,
          [key]: { loading: false, error: err as Error, slug: null },
        },
      }));
    }
  },
}));
